import { type ModuleData, ModuleProvider, useModule } from '#providers'

interface PensionConfig {
	pensionWindowUrl: string | null
	getMitIdLoginUrl: () => Promise<string>
	openPopup: (formRef: React.RefObject<HTMLFormElement>) => void
	registerPensionMessageListener: (
		updateVisibilityHandler: (event: any) => void,
		receivePopUpMessageHandler: (event: any) => void,
	) => () => void
}

interface PensionData {
	pensionSessionId: string
	shouldSkip: boolean
}

export type PensionModuleData = ModuleData<PensionData, void, PensionConfig>

export const PensionModuleProvider: typeof ModuleProvider<PensionModuleData> =
	ModuleProvider

export const usePensionModule: typeof useModule<PensionModuleData> = useModule
